import { createActions, createReducer } from "reduxsauce";

export interface BookingIdentUserData {
  nome: string;
  cpf: string;
  celular: string;
  email: string;
  cidade: string;
  estado: string;
  idUnidade: number | null;
  allowLocation: boolean;
  action: boolean;
}

export interface BookingIdentUserState {
  data: BookingIdentUserData[];
}

const { Types, Creators } = createActions(
  {
    setData: ["data"],
    reset: [],
  },
  { prefix: "BOOKING_IDENT_USER_" }
);

const INITIAL_STATE: BookingIdentUserState = {
  data: [],
};

const setData = (
  _state: BookingIdentUserState,
  action: { data: BookingIdentUserData[] }
): BookingIdentUserState => ({
  data: action.data,
});

const reset = (): BookingIdentUserState => INITIAL_STATE;

export const bookingIdentUser = createReducer(INITIAL_STATE, {
  [Types.SET_DATA]: setData,
  [Types.RESET]: reset,
});

export const BookingIdentUserTypes = Types;
export const BookingIdentUserActions = Creators;
